export { default } from "./accordion-item-provider";
